(function () {
  var root = document.querySelector('[data-ds-article]');
  if (!root) return;

  var content = root.querySelector('[data-article-content]');
  var tocLists = root.querySelectorAll('[data-article-toc-list], [data-article-mobile-toc-list]');
  var progress = root.querySelector('[data-article-progress]');
  var progressLabel = root.querySelector('[data-article-progress-label]');
  var copyLink = root.querySelector('[data-copy-article-link]');
  var headings = content ? Array.prototype.slice.call(content.querySelectorAll('h2, h3')) : [];

  function slugify(text, index) {
    return 'article-' + text.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + '-' + index;
  }

  function scrollToHeading(target) {
    var offset = window.matchMedia('(max-width: 880px)').matches ? 92 : 112;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  headings.forEach(function (heading, index) {
    if (!heading.id) heading.id = slugify(heading.textContent, index);
    heading.style.scrollMarginTop = '120px';
  });

  if (headings.length === 0) {
    root.querySelectorAll('[data-article-toc], [data-article-mobile-toc]').forEach(function (toc) {
      toc.hidden = true;
    });
  } else {
    tocLists.forEach(function (list) {
      headings.forEach(function (heading, index) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        if (heading.tagName.toLowerCase() === 'h3') link.className = 'is-sub';
        if (index === 0) link.classList.add('is-active');
        link.addEventListener('click', function (event) {
          event.preventDefault();
          scrollToHeading(heading);
          history.replaceState(null, '', '#' + heading.id);
        });
        item.appendChild(link);
        list.appendChild(item);
      });
    });
  }

  if ('IntersectionObserver' in window && headings.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        root.querySelectorAll('.ds-article-toc__list a').forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
        });
      });
    }, { rootMargin: '-35% 0px -55% 0px', threshold: 0.01 });
    headings.forEach(function (heading) { observer.observe(heading); });
  }

  function updateProgress() {
    if (!content || !progress || !progressLabel) return;
    var rect = content.getBoundingClientRect();
    var total = content.offsetHeight - window.innerHeight;
    var read = Math.min(Math.max((0 - rect.top + 120) / Math.max(total, 1), 0), 1);
    var percent = Math.round(read * 100);
    progress.style.width = percent + '%';
    progressLabel.textContent = percent + '%';
  }

  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);

  if (copyLink) {
    copyLink.addEventListener('click', function (event) {
      event.preventDefault();
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(window.location.href);
    });
  }
})();
